document.addEventListener('DOMContentLoaded', function() {
  if (!scrollContainer || !scrollThumb || !scrollTrack || !scrollIndicator) return;
  
  let isDragging = false;
  let isThumbDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let velocity = 0;
  let rafId = null;
  let lastScrollLeft = 0;
  let lastTime = Date.now();
  
  // Enhanced smooth scrolling with momentum
  function smoothScrollTo(targetScroll, duration = 300) {
    const startScroll = scrollContainer.scrollLeft;
    const distance = targetScroll - startScroll;
    const startTime = performance.now();
    
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }
    
    function animate(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeProgress = easeOutCubic(progress);
      
      scrollContainer.scrollLeft = startScroll + (distance * easeProgress);
      
      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    }
    
    requestAnimationFrame(animate);
  }
  
  function updateScrollIndicator() {
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const scrollLeft = scrollContainer.scrollLeft;
    
    // Hide indicator if content doesn't overflow
    const needsScrolling = scrollWidth > clientWidth;
    
    if (!needsScrolling) {
      scrollIndicator.style.display = 'none';
      return;
    } else {
      scrollIndicator.style.display = 'flex';
    }
    
    // Calculate scroll progress (0 to 1)
    const maxScroll = scrollWidth - clientWidth;
    const scrollProgress = maxScroll > 0 ? scrollLeft / maxScroll : 0;
    
    // Calculate thumb width relative to visible area
    const viewportRatio = clientWidth / scrollWidth;
    const thumbWidthPercent = Math.max(20, Math.min(80, viewportRatio * 100));
    
    // Get track dimensions
    const trackWidth = scrollTrack.offsetWidth;
    const thumbPixelWidth = (trackWidth * thumbWidthPercent) / 100;
    
    // Calculate the maximum translation
    const maxTranslate = trackWidth - thumbPixelWidth;
    
    // Calculate thumb position - ensure it reaches edges
    const translateX = scrollProgress * maxTranslate;
    
    // Apply styles with better performance
    scrollThumb.style.width = thumbWidthPercent + '%';
    scrollThumb.style.transform = `translate3d(${translateX}px, -50%, 0)`;
  }
  
  // Make scroll track clickable
  scrollTrack.addEventListener('click', function(e) {
    if (isThumbDragging) return;
    
    const rect = scrollTrack.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const trackWidth = rect.width;
    const thumbWidth = parseFloat(scrollThumb.style.width) / 100 * trackWidth;
    
    // Center the thumb on click position
    const targetThumbCenter = clickX;
    const targetThumbLeft = targetThumbCenter - (thumbWidth / 2);
    const maxThumbLeft = trackWidth - thumbWidth;
    const clampedThumbLeft = Math.max(0, Math.min(maxThumbLeft, targetThumbLeft));
    
    // Convert thumb position to scroll position
    const scrollProgress = maxThumbLeft > 0 ? clampedThumbLeft / maxThumbLeft : 0;
    const maxScroll = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    const targetScroll = scrollProgress * maxScroll;
    
    smoothScrollTo(targetScroll);
  });
  
  // Enhanced container scrolling with momentum
  let isScrolling = false;
  let startScrollX = 0;
  let scrollStartX = 0;
  
  function handleScrollStart(e) {
    if (e.target.closest('.awc_scroll_thumb')) return;
    
    // Don't start scrolling if clicking on a link
    if (e.target.closest('a')) return;
    
    isScrolling = true;
    scrollContainer.style.scrollBehavior = 'auto';
    startScrollX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    scrollStartX = scrollContainer.scrollLeft;
    velocity = 0;
    
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }
  
  function handleScrollMove(e) {
    if (!isScrolling) return;
    
    const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const deltaX = startScrollX - currentX;
    const newScrollLeft = scrollStartX + deltaX;
    
    // Calculate velocity for momentum
    const currentTime = Date.now();
    const timeDelta = currentTime - lastTime;
    const scrollDelta = newScrollLeft - lastScrollLeft;
    
    if (timeDelta > 0) {
      velocity = scrollDelta / timeDelta;
    }
    
    lastScrollLeft = newScrollLeft;
    lastTime = currentTime;
    
    scrollContainer.scrollLeft = newScrollLeft;
  }
  
  function handleScrollEnd() {
    if (!isScrolling) return;
    
    isScrolling = false;
    
    // Apply momentum
    if (Math.abs(velocity) > 0.2) {
      applyMomentum();
    }
  }
  
  function applyMomentum() {
    const friction = 0.95;
    const minVelocity = 0.2;
    
    function animate() {
      if (Math.abs(velocity) < minVelocity) {
        rafId = null;
        return;
      }
      
      scrollContainer.scrollLeft += velocity * 16; // 16ms frame time
      velocity *= friction;
      
      rafId = requestAnimationFrame(animate);
    }
    
    rafId = requestAnimationFrame(animate);
  }
  
  // Container scroll events for desktop
  scrollContainer.addEventListener('mousedown', handleScrollStart);
  document.addEventListener('mousemove', handleScrollMove);
  document.addEventListener('mouseup', handleScrollEnd);
  
  // Touch events for mobile - with proper handling for button clicks
  scrollContainer.addEventListener('touchstart', handleScrollStart, { passive: false });
  document.addEventListener('touchmove', handleScrollMove, { passive: false });
  document.addEventListener('touchend', handleScrollEnd);
  
  // Make thumb draggable
  function handleThumbDragStart(e) {
    isThumbDragging = true;
    startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    startScrollLeft = scrollContainer.scrollLeft;
    
    document.body.style.cursor = 'grabbing';
    scrollThumb.style.cursor = 'grabbing';
    
    e.preventDefault();
    e.stopPropagation();
  }
  
  function handleThumbDragMove(e) {
    if (!isThumbDragging) return;
    
    const currentX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
    const deltaX = currentX - startX;
    
    const trackWidth = scrollTrack.offsetWidth;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    
    // Get thumb width
    const thumbWidth = parseFloat(scrollThumb.style.width) / 100 * trackWidth;
    const maxThumbTranslate = trackWidth - thumbWidth;
    
    // Convert drag distance to scroll distance
    const dragRatio = deltaX / maxThumbTranslate;
    const scrollDelta = dragRatio * maxScroll;
    const newScrollLeft = Math.max(0, Math.min(maxScroll, startScrollLeft + scrollDelta));
    
    scrollContainer.scrollLeft = newScrollLeft;
  }
  
  function handleThumbDragEnd() {
    if (!isThumbDragging) return;
    
    isThumbDragging = false;
    document.body.style.cursor = '';
    scrollThumb.style.cursor = 'grab';
  }
  
  // Thumb drag events
  scrollThumb.addEventListener('mousedown', handleThumbDragStart);
  document.addEventListener('mousemove', handleThumbDragMove);
  document.addEventListener('mouseup', handleThumbDragEnd);
  
  scrollThumb.addEventListener('touchstart', handleThumbDragStart);
  document.addEventListener('touchmove', handleThumbDragMove);
  document.addEventListener('touchend', handleThumbDragEnd);
  
  // Optimize scroll performance
  let scrollRAF = null;
  function onScroll() {
    if (scrollRAF) return;
    scrollRAF = requestAnimationFrame(() => {
      updateScrollIndicator();
      scrollRAF = null;
    });
  }
  
  scrollContainer.addEventListener('scroll', onScroll, { passive: true });
  
  // Update on load and resize
  updateScrollIndicator();
  
  // Restore scroll position on page load (for seamless collection switching)
  const savedScrollPosition = sessionStorage.getItem('collectionScrollPosition');
  if (savedScrollPosition !== null) {
    // Small delay to ensure DOM is fully ready
    setTimeout(() => {
      scrollContainer.scrollLeft = parseInt(savedScrollPosition);
      updateScrollIndicator(); // Update indicator to match restored position
    }, 10);
    sessionStorage.removeItem('collectionScrollPosition');
  }
  
  // Save scroll position before navigating to a new collection
  const collectionLinks = scrollContainer.querySelectorAll('.awc_link');
  collectionLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      // Save current scroll position
      sessionStorage.setItem('collectionScrollPosition', scrollContainer.scrollLeft);
    });
  });
  
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateScrollIndicator, 150);
  });
  
  // Wheel scrolling with better acceleration
  scrollContainer.addEventListener('wheel', function(e) {
    if (e.deltaY !== 0) return; // Only handle horizontal scrolling
    
    e.preventDefault();
    const scrollAmount = e.deltaX * 2; // Accelerate scroll
    scrollContainer.scrollLeft += scrollAmount;
  }, { passive: false });
});